import { ElementType } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '$components'

export type BreadcrumbItem = {
  path: string
  label: string
  icon?: ElementType
}

export type BreadcrumbProps = {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <div className={cn('flex items-center gap-2 text-sm text-gray-500', className)}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <div
            key={index}
            className="flex items-center"
          >
            {index > 0 && (
              <span className="mr-2 mt-0.5 text-gray-400">
                /
              </span>
            )
            }

            { isLast
              ? (
                <span className="text-gray-900 font-medium flex items-center">
                  { item.icon && <item.icon className="size-4 mr-1" /> }
                  { item.label }
                </span>
              )
              : (
                <Link
                  to={item.path}
                  className="hover:text-gray-700 transition-colors flex items-center"
                >
                  { item.icon && <item.icon className="size-4 mr-1" /> }
                  { item.label }
                </Link>
              )
            }
          </div>
        )
      })}
    </div>
  )
}
